function monthsAndResourceTypes(t) {
  return {
    ACTIVE: t("ui.default.codes.ACTIVE"),
    PASSIVE: t("ui.default.codes.PASSIVE"),
    INITIAL: t("ui.default.codes.INITIAL"),
    COMPLETED: t("ui.default.codes.redemptionCompleted"),
    PARTIAL_PASSIVE: t("pages.default.organisationRegistration.partialPassive"),
    BLOCK: t("ui.default.codes.BLOCK"),
    CANCEL: t("ui.default.codes.CANCEL"),
    REPEAL: t("ui.default.codes.REPEAL"),
    REDEMPTION: t("ui.default.codes.REDEMPTION"),
    PRODUCTION: t("ui.default.codes.PRODUCTION"),
    RETAIL: t("ui.default.codes.RETAIL"),
    K1: t("ui.default.codes.K1"),
    K2: t("ui.default.codes.K2"),
    AGGREGATOR: t("ui.default.codes.AGGREGATOR"),
    BULK: t("ui.default.codes.BULK"),
    BIOMASS: t("ui.default.codes.BIOMASS"),
    WIND: t("ui.default.codes.WIND"),
    HYDROPOWER: t("ui.default.codes.HYDROPOWER"),
    GEOTHERMAL: t("ui.default.codes.GEOTHERMAL"),
    SOLAR: t("ui.default.codes.SOLAR"),
    CHARGING_NETWORK_OPERATOR: t("ui.default.codes.CHARGING_NETWORK_OPERATOR"),
    CONSUMER: t("pages.default.redemption.options.consumer"),
    PRODUCER: t("pages.default.redemption.options.producer"),
    IFSA_YESIL_TARIFE: t("pages.default.redemption.options.IFSA_YESIL_TARIFE"),
    IFSA: t("pages.default.redemption.options.IFSA"),
    1: t("ui.default.months.1"),
    2: t("ui.default.months.2"),
    3: t("ui.default.months.3"),
    4: t("ui.default.months.4"),
    5: t("ui.default.months.5"),
    6: t("ui.default.months.6"),
    7: t("ui.default.months.7"),
    8: t("ui.default.months.8"),
    9: t("ui.default.months.9"),
    10: t("ui.default.months.10"),
    11: t("ui.default.months.11"),
    12: t("ui.default.months.12"),
  };
}

function operationHistoryTrans(t) {
  return {
    EXPORT: t("pages.default.operationHistory.filters.export"),
    BILATERAL_AGREEMENT: t(
      "pages.default.operationHistory.filters.bilateralAgreement"
    ),
    REDEMPTION: t("pages.default.operationHistory.filters.redemption"),
    REGISTRY: t("pages.default.operationHistory.filters.registry"),
    GUARANTEE: t("pages.default.operationHistory.filters.guarantee"),
    EXCHANGE: t("pages.default.operationHistory.filters.exchange"),
    USER_MOVES: t("pages.default.operationHistory.filters.userMoves"),
    SYSTEM_PARAMETER: t(
      "pages.default.operationHistory.filters.systemParameter"
    ),
    BID: t("pages.default.operationHistory.filters.bid"),
    OBJECTION: t("pages.default.operationHistory.filters.objection"),
    MATCH: t("pages.default.operationHistory.filters.match"),
    CANCEL: t("pages.default.operationHistory.filters.cancel"),
    REPEAL: t("pages.default.operationHistory.filters.repeal"),
    ERROR_MESSAGE: t("pages.default.operationHistory.filters.errorMessage"),
    PROCESS_CHANGES: t("pages.default.operationHistory.filters.processChanges"),
    PROCESS_CREATE: t("pages.default.operationHistory.filters.processCreate"),
    CONTRACT: t("pages.default.operationHistory.filters.contract"),
    INFO: t("pages.default.operationHistory.filters.info"),
    USER: t("pages.default.operationHistory.filters.user"),
    SYSTEM: t("pages.default.operationHistory.filters.system"),
    GDDK: t("pages.default.operationHistory.filters.GDDK"),
    LIMIT_OPERATION: t("pages.default.operationHistory.filters.limitOperation"),
    ORDER: t("pages.default.operationHistory.filters.order"),
    TAKASBANK: t("pages.default.operationHistory.filters.takasBank"),
  };
}

function notificationTypes(t) {
  return {
    BILATERAL_AGREEMENT_SEND: t(
      "pages.default.notifications.settingsTable.rows.bilateralAgreementSend"
    ),
    BILATERAL_AGREEMENT_RECEIVE: t(
      "pages.default.notifications.settingsTable.rows.bilateralAgreementReceive"
    ),
    BILATERAL_AGREEMENT_APPROVAL: t(
      "pages.default.notifications.settingsTable.rows.bilateralAgreementAprroval"
    ),
    BILATERAL_AGREEMENT_PENDING_APPROVAL: t(
      "pages.default.notifications.settingsTable.rows.bilateralAgreementPendingAprroval"
    ),
    BILATERAL_AGREEMENT_CANCEL: t(
      "pages.default.notifications.settingsTable.rows.bilateralAgreementCancel"
    ),
    OBJECTION: t("pages.default.notifications.settingsTable.rows.objection"),
    PROCESS_CHANGES: t(
      "pages.default.notifications.settingsTable.rows.processChanges"
    ),
    DOCUMENT_EXPORT: t(
      "pages.default.notifications.settingsTable.rows.certificateExport"
    ),
    DOCUMENT_REPEAL: t(
      "pages.default.notifications.settingsTable.rows.certificateRepeal"
    ),
    REPEAL_INFORMATION: t(
      "pages.default.notifications.settingsTable.rows.repealInforming"
    ),
    REDEMPTION: t("pages.default.notifications.settingsTable.rows.redemption"),
    DOCUMENT_CANCEL: t(
      "pages.default.notifications.settingsTable.rows.certificateCancel"
    ),
    ORGANIZE_MARKET_MATCH_UP_INFORMATION: t(
      "pages.default.notifications.settingsTable.rows.organizedMarketMatchInfo"
    ),
    ORGANIZE_MARKET_CANCEL: t(
      "pages.default.notifications.settingsTable.rows.organizeMarketCancel"
    ),
    REGISTRATION: t(
      "pages.default.notifications.settingsTable.rows.registration"
    ),
    LIMIT_OPERATIONS: t(
      "pages.default.notifications.settingsTable.rows.limit_operation"
    ),
    GDDK: t("pages.default.notifications.settingsTable.rows.gddk"),
  };
}

function objectionStatus(t) {
  return {
    BUY: t("pages.default.marketResults.buy"),
    SELL: t("pages.default.marketResults.sell"),
    INITIAL: t("pages.default.objections.status.initial"),
    ACCEPTED: t("pages.default.objections.status.accepted"),
    REJECTED: t("pages.default.objections.status.rejected"),
  };
}

function exchangeOrder(t) {
  return {
    SYSTEM: t("pages.default.offerOperations.status.system"),
    USER_ACTION: t("pages.default.offerOperations.status.userAction"),
    CONTRACT_TIMEOUT: t("pages.default.offerOperations.status.contractTimeout"),
  };
}

function parameterNames(t) {
  return {
    minimum_repeal_period: t(
      "pages.default.systemParameters.parameters.minimumRepealPeriod"
    ),
    organized_market_starting_day: t(
      "pages.default.systemParameters.parameters.organizedMarketStartingDay"
    ),
    organized_market_opening_day: t(
      "pages.default.systemParameters.parameters.organizedMarketOpeningDay"
    ),
    yekg_certificate_repeal_time: t(
      "pages.default.systemParameters.parameters.yekgCertificateRepealTime"
    ),
    documentable_production_export_time: t(
      "pages.default.systemParameters.parameters.documentableProductionExportTime"
    ),
    organized_market_default_minimum_price: t(
      "pages.default.systemParameters.parameters.organizedMarketDefaultMinimumPrice"
    ),
    organized_market_default_maximum_price: t(
      "pages.default.systemParameters.parameters.organizedMarketDefaultMaximumPrice"
    ),
    objection_period: t(
      "pages.default.systemParameters.parameters.objectionPeriod"
    ),
    PIU: t("pages.default.systemParameters.parameters.PIU"),
    PIU_KATILIM: t("pages.default.systemParameters.parameters.PIU_KATILIM"),
    market_reconciliation: t(
      "pages.default.systemParameters.parameters.marketReconciliation"
    ),
  };
}
function processNames(t) {
  return {
    CONTRACT_PROCESS_TIME: t(
      "pages.default.systemParameters.processes.contractProcessTime"
    ),
    POST_SESSION_TIME: t(
      "pages.default.systemParameters.processes.postSessionTime"
    ),
    SESSION_TIME: t("pages.default.systemParameters.processes.sessionTime"),
  };
}

export {
  monthsAndResourceTypes,
  operationHistoryTrans,
  notificationTypes,
  objectionStatus,
  exchangeOrder,
  parameterNames,
  processNames,
};
